export const assignPriorityBasedOnProductName = (product: any) => {
  const { productName } = product

  return {
    ...product,
    priority: (() => {
      switch (true) {
        case productName.includes("Monarch"):
          return 1
        case productName.includes("Civilian"):
          return 2
        case productName.includes("Pathfinder"):
          return 3
        default:
          return 0
      }
    })(),
  }
}
